/* VINDRAX 1:1 Ionix theme JS (theme1to1). Small own runtime for the transplanted Ionix (Impact) DOM:
   drawers/popovers, variant picker, Kaching-look offer rows, add to cart, UpCart-look cart drawer. No external deps. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var PR = { products: {}, ph: {} };
  try { PR = JSON.parse($('#vx-prices').textContent); } catch (e) { }
  function cfg(h) { var c = (PR.products || {})[h]; if (c && c.same_as) c = PR.products[c.same_as]; return c || {}; }
  function money(c) { return (Math.round((c || 0) / 100)).toLocaleString('sv-SE').replace(/ /g, ' ') + ' kr'; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  var SW = { 'Svart': '#000000', 'Plommon': '#49292e', 'Grå': '#646964', 'Beige': '#EAD8AB', 'Rosa': '#e8afd2', 'Ljusblå': '#AEC6E5', 'Turkos': '#4194d2', 'Marinblå': '#3a485d', 'Orange': '#f0883e', 'Vit': '#ffffff', 'Nude': '#d9b99b', 'Vinröd': '#6d1f2c' };

  /* ---------- custom elements: no-op definitions so Impact's :defined CSS applies ---------- */
  var seen = {};
  $$('*').forEach(function (el) {
    var n = el.localName;
    if (n.indexOf('-') > 0 && !seen[n] && !customElements.get(n)) {
      seen[n] = 1;
      try { customElements.define(n, class extends HTMLElement { }); } catch (e) { }
    }
  });
  document.documentElement.classList.add('vx1-ready');

  /* ---------- drawers + popovers (Impact markup, [open] attribute) ---------- */
  function openEl(el, trigger) {
    if (!el) return;
    el.setAttribute('open', '');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    if (el.classList.contains('drawer')) document.documentElement.classList.add('vx1-lock');
    el._vxTrigger = trigger;
  }
  function closeEl(el) {
    if (!el) return;
    el.removeAttribute('open');
    if (el._vxTrigger) el._vxTrigger.setAttribute('aria-expanded', 'false');
    if (!$('.drawer[open]')) document.documentElement.classList.remove('vx1-lock');
  }
  document.addEventListener('click', function (e) {
    var path = e.composedPath ? e.composedPath() : [e.target];
    var inner = path[0];
    // close: overlay / close buttons (also inside shadow roots)
    for (var i = 0; i < path.length; i++) {
      var p = path[i];
      if (!p || !p.getAttribute) continue;
      if (p.getAttribute('part') === 'overlay' || p.getAttribute('is') === 'close-button') {
        var host = p.getRootNode && p.getRootNode().host ? p.getRootNode().host : p.closest('.drawer,.popover');
        if (host) { e.preventDefault(); closeEl(host); return; }
      }
      if (p.classList && (p.classList.contains('drawer') || p.classList.contains('popover'))) break;
    }
    var t = e.target.closest && e.target.closest('[aria-controls]');
    if (!t) return;
    var id = t.getAttribute('aria-controls');
    if (id === 'cart-drawer') { e.preventDefault(); openCart(); return; }
    var el = document.getElementById(id);
    if (!el || !(el.classList.contains('drawer') || el.classList.contains('popover'))) return;
    e.preventDefault();
    if (el.hasAttribute('open')) closeEl(el); else { $$('.popover[open]').forEach(closeEl); openEl(el, t); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { $$('.drawer[open],.popover[open]').forEach(closeEl); closeCart(); } });
  // sort-by popover in collections: navigate
  $$('x-listbox .popover-listbox__option[value]').forEach(function (b) {
    if (b.type === 'submit') return;
    b.addEventListener('click', function () { var u = new URL(location.href); u.searchParams.set('sort_by', b.value); location.href = u.toString(); });
  });

  /* ---------- cart api ---------- */
  function fetchCart() { return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function setCount(n) {
    $$('cart-count').forEach(function (c) {
      c.classList.toggle('opacity-0', !n);
      var a = $('[aria-hidden="true"]', c); if (a) a.textContent = n;
      var s = $('.sr-only', c); if (s) s.textContent = n + ' varor';
    });
  }
  function add(items) {
    return fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Något gick fel'); return j; }); })
      .then(function () { return openCart(); });
  }
  function change(key, q) {
    return fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: q }) })
      .then(function (r) { return r.json(); }).then(renderCart);
  }
  window.VX1 = { add: add, money: money };
  fetchCart().then(function (c) { setCount(c.item_count); }).catch(function () { });

  /* ---------- UpCart-look drawer (shadow root, like UpCart) ---------- */
  var host = $('#vx1-upcart'), shadow = null;
  function ensureShadow() {
    if (shadow || !host) return shadow;
    shadow = host.attachShadow({ mode: 'open' });
    var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = host.getAttribute('data-css'); shadow.appendChild(l);
    var st = document.createElement('style');
    st.textContent = ':host{all:initial;font-family:"GTStandard-M",sans-serif;} #upCart{font-family:"GTStandard-M",sans-serif;} .vx1-backdrop{position:fixed;inset:0;background:#000;opacity:.4;z-index:2147483639;display:none}.vx1-backdrop.on{display:block}';
    shadow.appendChild(st);
    var bd = document.createElement('div'); bd.className = 'vx1-backdrop'; shadow.appendChild(bd);
    shadow.appendChild($('#vx1-upcart-shell').content.cloneNode(true));
    host.hidden = false;
    bd.addEventListener('click', closeCart);
    shadow.addEventListener('click', onCartClick);
    shadow.addEventListener('change', function (e) {
      var li = e.target.closest('li[data-key]');
      if (li && e.target.matches('input')) change(li.getAttribute('data-key'), Math.max(0, parseInt(e.target.value, 10) || 0));
    });
    return shadow;
  }
  function openCart() {
    var s = ensureShadow(); if (!s) { location.href = root + 'cart'; return Promise.resolve(); }
    return fetchCart().then(function (c) {
      renderCart(c);
      var p = $('#CartPopup', s); if (p) p.classList.add('styles_active__');
      $('.vx1-backdrop', s).classList.add('on');
      document.documentElement.classList.add('vx1-lock');
    });
  }
  function closeCart() {
    if (!shadow) return;
    var p = $('#CartPopup', shadow); if (p) p.classList.remove('styles_active__');
    $('.vx1-backdrop', shadow).classList.remove('on');
    document.documentElement.classList.remove('vx1-lock');
  }
  function onCartClick(e) {
    var t = e.target;
    if (t.closest('.upcart-internal-header__close-button')) { closeCart(); return; }
    if (t.closest('[data-vx1-continue]')) { e.preventDefault(); closeCart(); return; }
    var li = t.closest('li[data-key]');
    if (li) {
      var key = li.getAttribute('data-key'), q = parseInt($('input', li).value, 10) || 0;
      if (t.closest('.upcart-internal-component-product-tile__quantity-minus')) change(key, Math.max(0, q - 1));
      else if (t.closest('.upcart-internal-component-product-tile__quantity-plus')) change(key, q + 1);
      else if (t.closest('.upcart-internal-component-product-tile__remove-button')) change(key, 0);
    }
    var ub = t.closest('[data-upcart-upsell] button');
    if (ub) {
      var tile = ub.closest('[data-upcart-upsell]'), sel = $('select', tile);
      ub.disabled = true;
      add([{ id: +(sel ? sel.value : ub.getAttribute('data-id')), quantity: 1 }]).catch(function (er) { alert(er.message); }).then(function () { ub.disabled = false; });
    }
  }
  function renderCart(c) {
    setCount(c.item_count);
    var s = shadow; if (!s) return c;
    var ul = $('[data-vx-items]', s), tpl = $('#vx1-upcart-item').content;
    var min = PR.free_ship_min || 0;
    // rewards bar
    var msg = $('.upcart-internal-rewards__message p', s), fill = $('.upcart-internal-component-segmented-progress-bar__segment-fill', s), ms = $('.upcart-internal-component-segmented-progress-bar__milestone-icon', s);
    var left = Math.max(0, min - c.total_price);
    if (msg) msg.innerHTML = left > 0 ? 'Du är <strong>' + money(left) + '</strong> från fri frakt!' : '🎉 Du har låst upp fri frakt!';
    if (fill) fill.style.width = (min ? Math.min(100, c.total_price / min * 100) : 100) + '%';
    if (ms) ms.setAttribute('data-internal-properties', 'isCompleted=' + (left === 0));
    ul.innerHTML = '';
    c.items.forEach(function (it) {
      var n = tpl.cloneNode(true), li = n.querySelector('li');
      li.setAttribute('data-key', it.key);
      $$('a', li).forEach(function (a) { a.href = it.url; });
      var im = $('img', li); if (im) { im.src = it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=200' : ''; im.alt = it.product_title; }
      var tl = $('.upcart-internal-component-product-tile__title-link', li); if (tl) tl.textContent = it.product_title;
      var rb = $('.upcart-internal-component-product-tile__remove-button', li); if (rb) rb.setAttribute('aria-label', 'Ta bort ' + it.product_title);
      var vv = $('.upcart-internal-cart-items__key-value-pair', li);
      var opts = (it.options_with_values || []).filter(function (o) { return o.name !== 'Title'; }).map(function (o) { return o.name + ': ' + o.value; }).join(', ');
      if (vv) { if (opts) vv.textContent = opts; else vv.parentNode.removeChild(vv); }
      var orig = it.original_line_price, fin = it.final_line_price;
      orig = Math.max(orig, (cfg(it.handle).compare || 0) * it.quantity);
      var ca = $('[data-upcart-chunk="cart-item-compare-at-price"]', li), pr = $('[data-upcart-chunk="cart-item-price"]', li), sv = $('[data-upcart-chunk="cart-item-savings"]', li);
      if (pr) pr.textContent = money(fin);
      if (orig > fin) { if (ca) ca.textContent = money(orig); if (sv) sv.textContent = '(Spara ' + money(orig - fin) + ')'; }
      else { if (ca) ca.textContent = ''; if (sv) sv.textContent = ''; $$('.upcart-internal__visually-hidden', li).forEach(function (x) { if (/Ordinarie|Original|Besparing|Savings/.test(x.textContent)) x.textContent = ''; }); }
      var q = $('input', li); if (q) q.value = it.quantity;
      var dc = $('.upcart-internal-component-product-tile__discount-codes', li);
      if (dc && !(it.line_level_discount_allocations || []).length) dc.parentNode.removeChild(dc);
      ul.appendChild(n);
    });
    // upsells
    var uw = $('[data-vx-upsells]', s), utpl = $('#vx1-upcart-upsell').content, ups = [];
    try { ups = JSON.parse($('#vx1-upsells').textContent); } catch (e) { }
    var inCart = c.items.map(function (x) { return x.handle; });
    if (uw) {
      uw.innerHTML = '';
      ups.filter(function (p) { return inCart.indexOf(p.handle) < 0; }).forEach(function (p) {
        var n = utpl.cloneNode(true), tile = n.querySelector('[data-upcart-upsell]');
        tile.setAttribute('data-upcart-upsell', p.handle);
        $$('a', n).forEach(function (a) { a.href = p.url; a.setAttribute('aria-label', p.title); });
        var im = $('img', n); if (im) { im.src = p.image; im.alt = p.title; }
        var t = $('.upcart-internal-component-upsell-tile__title', n); if (t) t.textContent = p.title;
        var op = $('[data-upcart-chunk="upsell-old-price"]', n), np = $('[data-upcart-chunk="upsell-new-price"]', n);
        if (np) np.textContent = money(p.price);
        var pc = Math.max(p.compare || 0, cfg(p.handle).compare || 0); if (op) op.textContent = pc > p.price ? money(pc) : '';
        var sel = $('select', n), btn = $('button', n);
        if (sel) {
          if (p.variants.length > 1) { sel.innerHTML = p.variants.map(function (v) { return '<option value="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' + esc(v.title) + '</option>'; }).join(''); sel.setAttribute('aria-label', 'Välj ' + p.title); }
          else { sel.parentNode.removeChild(sel); btn.setAttribute('data-id', p.variants[0].id); }
        }
        uw.appendChild(n);
      });
      var box = uw.closest('.upcart-internal-upsell'); if (box) box.style.display = uw.children.length ? '' : 'none';
    }
    // empty state
    var body = $('.upcart-cart-body', s);
    var foot = $('.upcart-footer', s);
    if (foot) foot.style.display = c.item_count ? '' : 'none';
    var em = $('.vx1-empty', s);
    if (!c.item_count) {
      if (!em && body) { em = document.createElement('div'); em.className = 'vx1-empty styles_CartPreview__empty__'; em.innerHTML = '<h3 style="padding:40px 0">Din varukorg är tom</h3>'; body.appendChild(em); }
    } else if (em) em.parentNode.removeChild(em);
    // summary
    var disc = c.items.reduce(function (a, it) { return a + (it.original_line_price - it.final_line_price); }, 0) + (c.cart_level_discount_applications || []).reduce(function (a, d) { return a + (d.total_allocated_amount || 0); }, 0);
    var dWrap = $('.upcart-internal-cart-summary', s);
    if (dWrap) dWrap.style.display = disc > 0 ? '' : 'none';
    var td = $('.upcart-internal-cart-summary__total-discount', s); if (td) td.textContent = '- ' + money(disc);
    var sub = $('.styles_Footer__cartSubtotalValue__', s); if (sub) sub.textContent = money(c.total_price);
    var cb = $('.styles_Footer__checkoutButton__ a', s);
    if (cb) { cb.href = root + 'checkout'; var lab = cb.querySelector('span') || cb; lab.textContent = 'Säker kassa ' + money(c.total_price); }
    var sk = $('.upcart-skeleton', s); if (sk) sk.style.display = 'none';
    return c;
  }

  /* ---------- quick add on product cards ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-vx1-qa]'); if (!b) return;
    e.preventDefault();
    if (b.getAttribute('data-vx1-multi') === '1') { location.href = b.getAttribute('data-url'); return; }
    b.setAttribute('aria-busy', 'true');
    add([{ id: +b.getAttribute('data-vx1-qa'), quantity: 1 }]).catch(function (er) { alert(er.message); }).then(function () { b.removeAttribute('aria-busy'); });
  });

  /* ---------- product page ---------- */
  var pjEl = $('script[data-vx1-product]');
  if (pjEl) initProduct(JSON.parse(pjEl.textContent));
  function initProduct(P) {
    var pdp = $('[data-vx1-pdp]') || document;
    var handle = P.handle, C = cfg(handle);
    var giftId = 0; try { giftId = JSON.parse($('script[data-vx1-gift]').textContent).id; } catch (e) { }
    var opts = P.options.map(function (o) { return typeof o === 'string' ? o : o.name; });
    function findV(vals) { return P.variants.filter(function (v) { return v.options.every(function (o, i) { return vals[i] == null || o === vals[i]; }); })[0]; }
    var form = $('form[data-vx1-form]', pdp);
    var idIn = form ? $('input[name=id]', form) : null;
    var current = P.variants.filter(function (v) { return idIn && v.id == idIn.value; })[0] || P.variants[0];

    // Impact variant picker
    var vp = $('variant-picker', pdp);
    function pickerVals() {
      var vals = opts.map(function () { return null; });
      $$('input[data-option-position]:checked', vp).forEach(function (i) { vals[+i.getAttribute('data-option-position') - 1] = i.getAttribute('data-vx1-val'); });
      return vals;
    }
    function setVariant(v) {
      if (!v) return;
      current = v;
      if (idIn) idIn.value = v.id;
      $$('.product-info__price price-list, .product-quick-add price-list, product-rerender price-list', document).forEach(function (pl) {
        if (pl.closest('.kaching-bundles')) return;
        var sp = $('sale-price', pl), cp = $('compare-at-price', pl);
        if (sp) { var srs = $('.sr-only', sp); sp.textContent = ''; if (srs) sp.appendChild(srs); sp.appendChild(document.createTextNode(' ' + money(v.price))); }
        if (cp) { var src = $('.sr-only', cp); cp.textContent = ''; if (src) cp.appendChild(src); var cmpv = Math.max(v.compare_at_price || 0, C.compare || 0); cp.appendChild(document.createTextNode(cmpv > v.price ? ' ' + money(cmpv) : '')); }
      });
      $$('buy-buttons button[type=submit]', pdp).forEach(function (b) { b.disabled = !v.available; var d = $('div', b); if (d) d.textContent = v.available ? 'Lägg i varukorgen' : 'Slutsåld'; });
    }
    if (vp) {
      // reflect current variant in the picker
      vp.addEventListener('change', function (e) {
        var inp = e.target; if (!inp.matches('input[data-option-position]')) return;
        var fs = inp.closest('fieldset');
        var sp = fs && $('.variant-picker__option-info span', fs); if (sp) sp.textContent = inp.getAttribute('data-vx1-val');
        var bs = fs && $('button.select span', fs); if (bs) bs.textContent = inp.getAttribute('data-vx1-val');
        var pop = inp.closest('.popover'); if (pop) closeEl(pop);
        setVariant(findV(pickerVals()) || current);
      });
      var v0 = findV(pickerVals()); if (v0) setVariant(v0);
    }

    // Kaching-look offer rows
    var kb = $('[data-vx1-kaching]', pdp);
    var tiers = (C && C.tiers) || [];
    function bars() { return kb ? $$('.kaching-bundles__bar', kb) : []; }
    function selectBar(bar) {
      bars().forEach(function (b) { var on = b === bar; b.classList.toggle('kaching-bundles__bar--selected', on); var r = $('input[type=radio]', b); if (r) r.checked = on; });
      updateAtcLabel();
    }
    function selectedBar() { return bars().filter(function (b) { return b.classList.contains('kaching-bundles__bar--selected'); })[0] || bars()[0]; }
    function colorValues() { var ci = opts.indexOf('Färg'); if (ci < 0) return []; var out = []; P.variants.forEach(function (v) { if (out.indexOf(v.options[ci]) < 0) out.push(v.options[ci]); }); return out; }
    function variantImage(color) {
      var ci = opts.indexOf('Färg'); var v = P.variants.filter(function (v) { return v.options[ci] === color && v.featured_image; })[0];
      return v ? v.featured_image.src + (v.featured_image.src.indexOf('?') > -1 ? '&' : '?') + 'width=120' : null;
    }
    if (kb) {
      kb.addEventListener('click', function (e) {
        if (e.target.closest('select, .kaching-bundles__swatch-dropdown, a')) return;
        var bar = e.target.closest('.kaching-bundles__bar'); if (bar) { e.preventDefault(); selectBar(bar); }
      });
      // colour swatch dropdowns -> transparent native select over the Kaching swatch (same look, native picker)
      var cols = colorValues();
      $$('.kaching-bundles__swatch-dropdown', kb).forEach(function (dd) {
        if (!cols.length) return;
        dd.style.position = 'relative';
        var s = document.createElement('select');
        s.className = 'vx1-kswatch';
        s.setAttribute('aria-label', 'Färg');
        s.innerHTML = cols.map(function (c) { return '<option' + (c === dd.getAttribute('data-value') ? ' selected' : '') + '>' + esc(c) + '</option>'; }).join('');
        s.style.cssText = 'position:absolute;inset:0;opacity:0;width:100%;height:100%;cursor:pointer;font-size:16px';
        dd.appendChild(s);
        s.addEventListener('change', function () {
          dd.setAttribute('data-value', s.value);
          var lab = $('span[role=combobox] > span', dd); if (lab) lab.textContent = s.value;
          var sw = $('.kaching-bundles__swatch', dd); if (sw && SW[s.value]) { sw.style.setProperty('--kaching-swatch-color', SW[s.value]); sw.style.setProperty('--kaching-swatch-border-color', SW[s.value]); }
          var row = dd.closest('.kaching-bundles__bar-variant'), im = row && $('.kaching-bundles__bar-variant-image', row), u = variantImage(s.value);
          if (im && u) im.src = u;
        });
      });
      $$('select.kaching-bundles-option', kb).forEach(function (s) { s.addEventListener('change', function () { s.setAttribute('data-value', s.value); }); });
      // initial row images = our variant images
      $$('.kaching-bundles__swatch-dropdown', kb).forEach(function (dd) { var row = dd.closest('.kaching-bundles__bar-variant'), im = row && $('.kaching-bundles__bar-variant-image', row), u = variantImage(dd.getAttribute('data-value')); if (im && u) im.src = u; });
      var gi = $('.kaching-bundles__free-gift__image', kb);
    }
    function kachingItems() {
      var bar = selectedBar(); if (!bar) return null;
      var q = +bar.getAttribute('data-vx1-q') || 1, ti = +bar.getAttribute('data-vx1-tier') || 0, items = [];
      if (C.mode === 'variant') { var v = P.variants[ti] || P.variants[0]; items.push({ id: v.id, quantity: 1 }); }
      else {
        var rows = $$('.kaching-bundles__bar-variant', bar);
        if (!rows.length) items.push({ id: (current || P.variants[0]).id, quantity: q });
        rows.forEach(function (r) {
          var vals = opts.map(function () { return null; });
          $$('[data-name]', r).forEach(function (o) { var i = opts.indexOf(o.getAttribute('data-name')); if (i > -1) vals[i] = o.tagName === 'SELECT' ? o.value : o.getAttribute('data-value'); });
          var v = findV(vals);
          if (!v) throw new Error('Den kombinationen finns inte.');
          if (!v.available) throw new Error(v.title + ' är slutsåld.');
          var ex = items.filter(function (x) { return x.id === v.id; })[0];
          if (ex) ex.quantity++; else items.push({ id: v.id, quantity: 1 });
        });
      }
      if (bar.getAttribute('data-vx1-gift') && giftId) items.push({ id: giftId, quantity: 1, properties: { _vx_gift: '1' } });
      return items;
    }
    function updateAtcLabel() {
      var bar = kb && selectedBar(); if (!bar) return;
      var tot = +bar.getAttribute('data-vx1-total');
      $$('.product-quick-add sale-price', document).forEach(function (sp) { var s = $('.sr-only', sp); sp.textContent = ''; if (s) sp.appendChild(s); sp.appendChild(document.createTextNode(' ' + money(tot))); });
    }
    if (kb) updateAtcLabel();

    // quantity selector (Impact quantity-selector)
    $$('quantity-selector', pdp).forEach(function (qs) {
      var inp = $('input', qs);
      qs.addEventListener('click', function (e) { var b = e.target.closest('button'); if (!b || !inp) return; e.preventDefault(); var d = b.getAttribute('aria-label') && /minska|decrease|-/i.test(b.getAttribute('aria-label') + b.textContent) ? -1 : 1; inp.value = Math.max(1, (+inp.value || 1) + d); });
    });

    function submit(e) {
      if (e) e.preventDefault();
      var items;
      try {
        items = kb ? kachingItems() : null;
        if (!items) { var qi = $('quantity-selector input, input[name=quantity]', pdp); items = [{ id: +(idIn ? idIn.value : current.id), quantity: qi ? Math.max(1, +qi.value || 1) : 1 }]; }
      } catch (er) { alert(er.message); return; }
      var btns = $$('buy-buttons button', document); btns.forEach(function (b) { b.setAttribute('aria-busy', 'true'); });
      add(items).catch(function (er) { alert(er.message); }).then(function () { btns.forEach(function (b) { b.removeAttribute('aria-busy'); }); });
    }
    if (form) form.addEventListener('submit', submit);
    // sticky add-to-cart bar (Impact product-quick-add): same submit
    $$('.product-quick-add buy-buttons button', document).forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); var t = kb || form; if (window.innerWidth < 700 && t) { t.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; } submit(e); }); });
    var qa = $('.product-quick-add'), main = form && $('buy-buttons', form);
    if (qa && main && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { en.forEach(function (x) { qa.toggleAttribute('visible', !x.isIntersecting && x.boundingClientRect.top < 0); qa.classList.toggle('is-visible', !x.isIntersecting && x.boundingClientRect.top < 0); }); }).observe(main);
    }
  }

  /* ---------- product gallery: thumbnails / dots scroll the carousel (Impact media-carousel = scroll-snap) ---------- */
  $$('product-gallery').forEach(function (g) {
    var list = $('media-carousel', g); if (!list) return;
    $$('.product-gallery__thumbnail, [data-vx1-thumb]', g).forEach(function (t, i) {
      t.addEventListener('click', function (e) { e.preventDefault(); var m = $$('.product-gallery__media', list)[i]; if (m) list.scrollTo({ left: m.offsetLeft - list.offsetLeft, behavior: 'smooth' }); });
    });
  });

  /* ---------- Judge.me-look review photo strip arrows ---------- */
  $$('.jm-media-grid').forEach(function (g) {
    var c = $('.jm-media-grid__container', g), n = $('.jm-media-grid__arrow--next', g), p = $('.jm-media-grid__arrow--prev', g);
    if (n && c) n.addEventListener('click', function () { c.scrollBy({ left: c.clientWidth * 0.8, behavior: 'smooth' }); });
    if (p && c) p.addEventListener('click', function () { c.scrollBy({ left: -c.clientWidth * 0.8, behavior: 'smooth' }); });
  });
  // review photo lightbox: open the image in a simple overlay
  document.addEventListener('click', function (e) {
    var t = e.target.closest('.jm-media-thumbnail-list__thumbnail, .jm-media-grid__item'); if (!t) return;
    var im = $('img', t); if (!im) return;
    var o = document.createElement('div');
    o.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,.85);z-index:2147483647;display:flex;align-items:center;justify-content:center;cursor:zoom-out';
    o.innerHTML = '<img src="' + esc(im.src) + '" alt="Kundfoto" style="max-width:92vw;max-height:88vh;border-radius:8px">';
    o.addEventListener('click', function () { o.remove(); });
    document.body.appendChild(o);
  });


  /* ---------- Kaching badge ring ("Begränsat erbjudande" text around the selected card): recompute for the real card size, like Kaching does ---------- */
  function ring(svg) {
    var box = svg.parentNode.getBoundingClientRect(), w = box.width, h = box.height; if (!w || !h) return;
    var th = parseFloat(getComputedStyle(svg.parentNode).getPropertyValue('--badge-border-thickness')) || 16;
    var i = th * 0.7, r = th * 2.2, ns = 'http://www.w3.org/2000/svg';
    var loop = 'H ' + (w - i - r) + ' A ' + r + ' ' + r + ' 0 0 1 ' + (w - i) + ' ' + (i + r) + ' V ' + (h - i - r) + ' A ' + r + ' ' + r + ' 0 0 1 ' + (w - i - r) + ' ' + (h - i) + ' H ' + (i + r) + ' A ' + r + ' ' + r + ' 0 0 1 ' + i + ' ' + (h - i - r) + ' V ' + (i + r) + ' A ' + r + ' ' + r + ' 0 0 1 ' + (i + r) + ' ' + i + ' ';
    svg.setAttribute('viewBox', '0 0 ' + w + ' ' + h);
    var path = svg.querySelector('path'), text = svg.querySelector('text'); if (!path || !text) return;
    path.setAttribute('d', 'M ' + (i + r) + ' ' + i + ' ' + loop + loop + 'Z');
    if (!svg._label) { var tps = text.querySelectorAll('textPath'); svg._label = ''; for (var k = 0; k < tps.length; k++) { var t = tps[k].textContent.trim(); if (t && t !== '•') { svg._label = t; break; } } }
    var L = 2 * (w - 2 * i - 2 * r) + 2 * (h - 2 * i - 2 * r) + 2 * Math.PI * r;
    var id = path.id; text.textContent = '';
    var probe = document.createElementNS(ns, 'textPath'); probe.setAttribute('href', '#' + id); probe.textContent = svg._label; text.appendChild(probe);
    var tw = probe.getComputedTextLength() || svg._label.length * 6; text.removeChild(probe);
    var n = Math.max(2, Math.floor(L / (tw + 24))), step = L / n;
    for (var j = 0; j < n; j++) {
      var a = document.createElementNS(ns, 'textPath'); a.setAttribute('href', '#' + id); a.setAttribute('startOffset', (j * step + step / 2)); a.textContent = svg._label; text.appendChild(a);
      var b = document.createElementNS(ns, 'textPath'); b.setAttribute('href', '#' + id); b.setAttribute('startOffset', ((j + 1) * step)); b.textContent = '•'; text.appendChild(b);
    }
  }
  function rings() { $$('.kaching-bundles__badge-border__curve').forEach(ring); }
  rings(); window.addEventListener('resize', function () { clearTimeout(rings._t); rings._t = setTimeout(rings, 150); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(rings);

  /* ---------- "Ships by <date>" (next business day, Swedish) ---------- */
  (function () {
    var d = new Date(); d.setDate(d.getDate() + 1);
    while (d.getDay() === 0 || d.getDay() === 6) d.setDate(d.getDate() + 1);
    var m = ['jan', 'feb', 'mars', 'apr', 'maj', 'juni', 'juli', 'aug', 'sep', 'okt', 'nov', 'dec'];
    $$('[data-vx-shipdate]').forEach(function (el) { el.textContent = d.getDate() + ' ' + m[d.getMonth()]; });
  })();
})();
